import styled from 'styled-components';
import { SkeletonRectangle } from '../';
// *** Components ***
export const Image = styled(SkeletonRectangle) `
  ${({ $height }) => $height && `height: ${$height}`};
  ${({ $width }) => $width && `width: ${$width}`};
`;
//# sourceMappingURL=skeleton-image.styles.js.map